import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import isEmail from 'validator/lib/isEmail';
import isMatch from 'lodash/isMatch';

import messages from './messages';
import UserSelector from './userSelector';

import Toast from '../../components/Toast';
import Header from '../../components/Header';
import Form from '../../components/Form';
import Label from '../../components/Label';
import TextArea from '../../components/TextArea';
import PageTitle from '../../components/PageTitle';

import './styles.css';

class InstitutionNotificationSettingsPage extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    heCommunityContacts: PropTypes.array.isRequired,
    activeMatchNotificationsAdditionalEmails: PropTypes.string.isRequired,
    activeMatchNotificationsContacts: PropTypes.array.isRequired,
    heUsers: PropTypes.array.isRequired,
    onSave: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { activeMatchNotificationsAdditionalEmails, activeMatchNotificationsContacts } = this.props;
    this.state = { saveError: false, success: false };
    this.state.additionalMails = activeMatchNotificationsAdditionalEmails;
    this.state.validAdditionalMails = true;
    // keep track of id's of contact that are selection.
    this.state.selectedContactIds = activeMatchNotificationsContacts.filter((contact) => !!contact).map((contact) => contact.id);
  }

  onAdditionalMailsChange = (_, { value }) => {
    this.setState({ additionalMails: value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const valid = this.validate();

    if (valid) {
      this.setState({ success: false });
      const { additionalMails, selectedContactIds } = this.state;
      this.props.onSave({
        activeMatchNotificationsAdditionalEmails: additionalMails,
        activeMatchNotificationsContactIds: selectedContactIds,
      }, this.onSaveError, this.onSaveSuccess);
    }
  };

  onSaveError = () => {
    this.setState({ saveError: true });
  };

  onSaveSuccess = () => {
    this.setState({ saveError: false, success: true });
  };

  hideSuccessMessage = () => {
    this.setState({ success: false });
  };

  hideFailureMessage = () => {
    this.setState({ saveError: false });
  };

  validate = () => {
    let validAdditionalMails = true;
    const { additionalMails } = this.state;
    if (additionalMails && additionalMails.trim() !== '') {
      validAdditionalMails = additionalMails.split(',').every((x) => isEmail(x.trim()));
    }

    this.setState({ validAdditionalMails });
    return validAdditionalMails;
  };

  storeSelectionChange = (selectedContactsId) => {
    this.setState({ selectedContactIds: selectedContactsId });
  };

  render() {
    const { validAdditionalMails, additionalMails, success, saveError, selectedContactIds } = this.state;
    const { intl, heCommunityContacts, heUsers } = this.props;
    // find the communityContacts that are also HE admin users.
    const users = heCommunityContacts.filter((contact) =>
      heUsers.find((user) => isMatch(user, { role: 'administrator', email: contact.mail })));

    return (
      <div styleName="notifications-body">
        <PageTitle subTitle="Institution Notifications" title="Settings" category="Intersect" />
        <Form onSubmit={this.onSubmit} id="form-repvisits-institution-settings">
          <Header as="h2" styleName="pageHeader" id="right-side-heading">
            <FormattedMessage {...messages.institutionNotifications} />
          </Header>
          <p><FormattedMessage {...messages.pageInstructions} /> </p>
          <Header as="h3" styleName="form-section-heading">
            <FormattedMessage {...messages.intersectActiveMatchHeading} />
          </Header>
          <Header as="h4" styleName="field-group-heading">
            <FormattedMessage {...messages.intersectActiveMatchWeeklyReportHeading} />
          </Header>
          <p>
            <FormattedMessage {...messages.intersectActiveMatchWeeklyReportDescription} />
          </p>
          <div styleName="recipientOptionsSection">
            <div id="users-notif-group">
              <FormattedMessage {...messages.activeMatchWeeklyReportInstructions} />:
            </div>
            <UserSelector
              users={users}
              selectedUserIds={selectedContactIds}
              onSelectionChange={this.storeSelectionChange}
              prefix="am_notification_contacts_"
            />
            <Form.Field error={!validAdditionalMails}>
              <label htmlFor="am_notification_contacts_additional_emails">
                <FormattedMessage {...messages.additionalEmailsLabel} />
              </label>
              <TextArea
                id="am_notification_contacts_additional_emails"
                name="amAdditionalEmails"
                autoHeight
                placeholder={intl.formatMessage(messages.additionalEmailsPlaceholder)}
                onChange={this.onAdditionalMailsChange}
                value={additionalMails}
                styleName="textarea-focus-color"
              />
            </Form.Field>
            {!validAdditionalMails && (
            <Label role="tooltip" data-cy="notification-error-message-tooltip" basic color="red" pointing>
              <FormattedMessage {...messages.invalidEmailAddresses} />
            </Label>
            )}
          </div>
          <div styleName="button-section">
            <Form.Button primary type="submit">
              <FormattedMessage {...messages.buttonSave} />
            </Form.Button>
          </div>
        </Form>
        <Toast
          active={success}
          title={<FormattedMessage {...messages.changeSuccessTitle} />}
          description={<FormattedMessage {...messages.changeSuccessDescription} />}
          onDeactivate={this.hideSuccessMessage}
        />
        <Toast
          active={saveError}
          title=""
          kind="error"
          description={this.props.intl.formatMessage(messages.failureDescription)}
          onDeactivate={this.hideFailureMessage}
        />
      </div>
    );
  }
}

export default injectIntl(InstitutionNotificationSettingsPage);
